import { render, staticRenderFns } from "./VacancyFaqForm.vue?vue&type=template&id=97e3c5fa&"
import script from "./VacancyFaqForm.vue?vue&type=script&lang=js&"
export * from "./VacancyFaqForm.vue?vue&type=script&lang=js&"
import style0 from "./VacancyFaqForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./VacancyFaqForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyFaqForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow,VTextField,VTextarea})
